import { render, staticRenderFns } from "./search-forms.vue?vue&type=template&id=11585068&scoped=true&"
import script from "./search-forms.vue?vue&type=script&lang=js&"
export * from "./search-forms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11585068",
  null
  
)

export default component.exports